const Breadcrumb = ({ title, claimId }) => {
  return (
    <div
      className={`d-flex flex-wrap align-items-center justify-content-between gap-3 
      ${claimId ? "claim-header-compact" : ""}`} style={{marginBottom:"3px"}}>

      <h6 className='fw-semibold mb-0'>{title}</h6>

      {claimId && (
        <span className="text-secondary small claim-case-id">
          Case ID: {claimId}
        </span>
      )}
    </div>
  );
};

export default Breadcrumb;
